'use client';

import { useEffect } from 'react';

// Mounts inside app/not-found.tsx. Fires a single beacon to log the 404
// only when the not-found UI actually reaches the user's browser. This
// avoids the false-positive problem with server-side logging in
// not-found.tsx, where Next 16 also renders the component during parallel
// route segment resolution (those renders never get committed to the
// real DOM and would otherwise spam 404 entries on every admin page
// navigation).

export function NotFoundReporter() {
  useEffect(() => {
    const path = window.location.pathname + window.location.search;
    // Skip the noise paths that come from bots probing for files we
    // don't host. Same list as the (now-dead) drain receiver path filter.
    const NOISE = [
      /^\/sw\.js$/,
      /^\/apple-touch-icon/,
      /^\/robots\d*\.txt$/,
      /^\/\.well-known\//,
      /^\/wp-/,
      /^\/wordpress/i,
      /\.(?:env|git|sql|bak|php|asp|aspx|jsp)$/i,
    ];
    if (NOISE.some((re) => re.test(window.location.pathname))) return;

    const body = JSON.stringify({ url: path });
    try {
      if (typeof navigator.sendBeacon === 'function') {
        const blob = new Blob([body], { type: 'application/json' });
        if (navigator.sendBeacon('/api/internal/log-404', blob)) return;
      }
      void fetch('/api/internal/log-404', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body,
        keepalive: true,
      }).catch(() => undefined);
    } catch {
      // Reporter must never throw.
    }
  }, []);

  return null;
}
